import { isBuilderPreview } from './isBuilderPreview';

export const isBuilderContentReady = ({ isLoading, content }) => {
  return isBuilderPreview() || (!!content && !isLoading);
};
